import Vue from 'vue';
import VueRouter from 'vue-router';

import Accueil from '../views/EleveInscriptionView.vue';
import BoutiqueView from '../views/BoutiqueView.vue';
import InfoElevePanierView from '../views/InfoElevePanierView.vue';
import ProcederPaiementView from '../views/ProcederPaiementView.vue';
import ConfirmationPaiementView from '../views/ConfirmationPaiementView.vue';
import DemandeContactView from '../views/DemandeContactView.vue';

Vue.use(VueRouter);

export default new VueRouter({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'accueil',
      component: Accueil,
    },
    {
      path: '/Panier',
      name: 'infoElevePanier',
      component: InfoElevePanierView,
    },
    {
      path: '/Boutique',
      name: 'boutique',
      component: BoutiqueView,

    },
    {
      path: '/Paiement',
      name: 'paiement',
      component: ProcederPaiementView,

    },
    {
      path: '/Paiement/Confirmation/:guid',
      name: 'confirmation',
      component: ConfirmationPaiementView,
      props: true,
    },
    {
      path: '/DemandeContact',
      name: 'demandeContact',
      component: DemandeContactView,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
